module.exports = function lines(str) {
  if (str == null) return [];
  return String(str).split(/\r\n?|\n/);
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/lines.js
// module id = vRPJ
// module chunks = 0